module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/costume_03@2x-5ae439b5e372d3e87c3e6034983726f3.webp";